import React, { Fragment } from 'react'
import PropTypes, { InferProps } from 'prop-types'
import { Box, List } from 'pcln-design-system'
export const props = {
  /** JSDoc-style comments on props will appear in the Docs tab in Storybook */
  props: PropTypes.object,
}

import { ParentFlex, StyledTileWrapper } from './SopqDetailsLearnMore.styles'
import SopqTitleLearnMore from './SopqTitleLearnMore'

export type SopqDetailsLearnMoreProps = InferProps<typeof props>

const generateMainContent = (props) => {
  return (
    <Fragment>
      <List.ul pl='16px' color='text.light' m='0px'>
        {props.points.map(function (object, i) {
          return (
            <li
              key={`sopqDetailsMainContent-${i}`}
              style={{ margin: '0px 0px 16px 0px', fontSize: '14px' }}
              color='text.light'
            >
              {object}
            </li>
          )
        })}
      </List.ul>
    </Fragment>
  )
}
/** @public */
const SopqDetailsLearnMore: React.FC<SopqDetailsLearnMoreProps> = ({ props }: SopqDetailsLearnMoreProps) => {
  return (
    <StyledTileWrapper borderRadius='12px' boxShadowSize='sm'>
      <Box color='primary.base' height='6px' />
      <ParentFlex
        flexDirection='column'
        color='background.lightest'
        borderRadius='xl'
        {...props}
        data-testid='learn-more-tile'
      >
        <SopqTitleLearnMore />
        <Box mx={3}>
          {generateMainContent(props)}
        </Box>
      </ParentFlex>
    </StyledTileWrapper>
  )
}

SopqDetailsLearnMore.propTypes = props

export default SopqDetailsLearnMore
